module.exports = __webpack_public_path__ + "resources/img/img_alyac1_en.7255b71485d8f87e25f01feb7ce73062.png";